export default {
    FONT: {
        XSMALL: 10,
        SMALL: 12,
        BASE: 14,
        LARGE: 16,
        XLARGE: 18,
        XXLARGE: 22,
    },
    FULL_SCREEN_MODAL: {
        FOOTER_HEIGHT: 72,
    },
    MODAL: {
        HEADER_HEIGHT: 44,
        MARGIN_X: 16,
        MARGIN_Y: 32,
        FOOTER_HEIGHT: 63,
        CONTENT: {
            PADDING_Y: 40,
            PADDING_Y_FOR_SUB_CONTENT: 10,
        },
        CONFIRMATION: {
            MAX_WIDTH: 343,
            MIN_WIDTH: 288,
            INNER: {
                MIN_WIDTH: 188,
            },
        },
        SUB_CONTENT: {
            HEIGHT: 86,
        },
    },
    NOTIFICATION_BAR: {
        HEIGHT: 32,
        HEIGHT_SP: 24,
    },
    WAIT_TYPE_FILTER: {
        HEIGHT: 120,
    },
    WAIT_COUNT_TIME_PANEL: {
        HEIGHT: 120,
    },
    WAIT_TYPE_TABS: {
        HEIGHT: 42,
    },
    RESERVE_LIST: {
        ROW: {
            HEIGHT: 104,
            UPPER_ROW_HEIGHT: 60,
            LOWER_ROW_HEIGHT: 36,
            PADDING_X: 16,
            PADDING_Y: 8,
        },
    },
    INPUT: {
        HEIGHT: 42,
    },
};
//# sourceMappingURL=size.js.map